import React from 'react';

import { FlexCenterWrapper, Wrapper, TextContainer, Title, SubTitle } from './NoSearchResults.styles';
import { Skeleton } from 'components/styled/skeleton';

const NoSearchResults = (props) => {
  return (
    <FlexCenterWrapper>
      <Wrapper>
        <TextContainer>
          {props.title && <Title>{props.title}</Title>}
          {props.subTitle && <SubTitle>{props.subTitle}</SubTitle>}
        </TextContainer>
        <div style={{ width: '253px' }}>
          <Skeleton height="12px" width="96px" margin="0 0 12px 0" />
          <Skeleton height="12px" width="253px" margin="0 0 12px 0" />
          <Skeleton height="12px" width="96px" margin="0 0 12px 0" />
          <Skeleton height="12px" width="253px" margin="0 0 12px 0" />
          <Skeleton height="12px" width="96px" margin="0 0 12px 0" />
          <Skeleton height="12px" width="253px" margin="0" />
        </div>
      </Wrapper>
    </FlexCenterWrapper>
  );
};

export default NoSearchResults;
